<script setup>
const props = defineProps({
    sessions: {
        type: Array,
        required: true
    },
    hero: {
        type: Boolean,
        required: false,
        default: false,
    }
})

const sortedSessions = computed(() => {
    return [...props.sessions].sort((a, b) => {
        return a.title.localeCompare(b.title)
    })
})

</script>

<template>
    <div class="speaker-sessions" :class="{ 'hero': hero }">
        <div class="container">
            <h2 class='h2' v-if='hero'>Speaker Sessions</h2>
            <h3 class='h2' v-else>Speaker Sessions</h3>
            <ul class='session-list'>
                <li v-for="(session, index) in sortedSessions" :key="session.id">
                    <SessionsCard :session="session" wide teal full sessionsUrl="/sessions" show_sponsors />
                </li>
            </ul>
        </div>
    </div>
</template>

<style lang="scss">
    .speaker-sessions {
        background: var(--teal);
        color: var(--cream);
        
        &.hero {
            padding-bottom: 4.5rem;
        }
        

        .h2 {
            font-size: 3rem;
            font-weight: 500;
            line-height: 3.375rem;
            letter-spacing: -0.03rem;
            margin-bottom: 2.875rem;
        }

        .session-list {
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: 2rem;            
        }

        .session-card {
            background: var(--teal-darkish);
            color: var(--cream);
            

            &.hover {
                
                .description { color: var(--orange-for-teal); }
            }
            
            a {
                @include hover {
                    color: var(--orange-for-teal);
                }
            }

            .featured {
                color: var(--orange-for-teal);
            }

            .description {
                color: var(--sage);

                @include hover {
                    color: var(--orange-for-teal);
                }
            }

            .project-tag {
                color: var(--sage);
                @include hover {
                    color: var(--orange-for-teal);
                }
            }
        }

    }
</style>